export type SingingTipsVideo = {
  id: string;
  title: string;
  topic: string;
  summary: string;
};

// Selected from the brand's 19 August 2026 social-video performance review and
// verified against its public YouTube Shorts inventory on 6 October 2026.
// The review singled out vowels, high-note space, ear tests and belting for
// reach, watch quality or follower growth. Public counts are deliberately
// omitted: platform definitions differ and the review is a dated snapshot.
export const singingTipsVideos: readonly SingingTipsVideo[] = [
  {
    id: "MF6KshYA2lE",
    title: "Most singers make this vowel mistake",
    topic: "Vowel clarity",
    summary: "Listen to how the sound changes across vowels. A small change can give you a useful clue about your voice.",
  },
  {
    id: "uP8nmLyvEXI",
    title: "High notes need space, not force",
    topic: "High notes",
    summary: "Hear a demonstration of a clearer high-note setup, and notice what happens before adding more effort.",
  },
  {
    id: "602v2YTSCIU",
    title: "Can you name these six vocal techniques?",
    topic: "Train your ear",
    summary: "A short listening challenge to help you recognise different vocal sounds and build your musical ear.",
  },
  {
    id: "rqNDqw0ovhQ",
    title: "Three belting tips without shouting",
    topic: "Power & coordination",
    summary: "Explore the difference between a powerful sound and pushing harder, with three focused coaching cues.",
  },
  {
    id: "GpqbjSv1JYc",
    title: "Can you hear the high-note break disappear?",
    topic: "Hear the change",
    summary: "Listen for the change in a high-note transition. Use the comparison to become more aware of your own coordination.",
  },
  {
    id: "EbY5htg4kKk",
    title: "Stop singing louder: tension & release",
    topic: "Less effort",
    summary: "Notice the relationship between volume and tension, and why more effort is not always the next useful step.",
  },
];
